import { configureStore } from "@reduxjs/toolkit";
import authReducer from "../features/auth/auth.slice";
import toastReducer from "../features/toast/toast.slice";
import { apiSlice } from "./apiSlice";
import "../features/upload/upload.api";
import "../features/fAndB/fnbRestaurants.api";
import "../features/cabana/cabanas.api";

export const store = configureStore({
	reducer: {
		[apiSlice.reducerPath]: apiSlice.reducer,
		auth: authReducer,
		toast: toastReducer,
	},
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware({
			serializableCheck: {
				ignoredPaths: ["api"],
			},
		}).concat(apiSlice.middleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
